module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-conscription.76172f4f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-top-conscription.png
// module id = 2848
// module chunks = 11